import { useMutationEndpoint, UseMutationOptionsFromProvider } from '../../core'
import { postAuthTokenExchange } from '../endpoints'

type MutationParams = Parameters<typeof postAuthTokenExchange>[0]

export const useAuthTokenExchangePostMutation = (
  options?: UseMutationOptionsFromProvider<
    typeof postAuthTokenExchange,
    MutationParams
  >,
) =>
  useMutationEndpoint(
    (data: MutationParams) => postAuthTokenExchange(data),
    options,
  )
